import { useDispatch, useSelector } from 'react-redux'
import LogoGradientIcon from '../../icons/LogoGradientIcon'
import { selectIntegrations, setIntegrationsToShow } from '../../reducers/integrations'
import { SegmentedControl } from '@radix-ui/themes'
import { inPov } from '../../utils/session'
import { selectUser } from '../../reducers/users'

interface IHeaderProps {
  pageTitle?: string
}

const IntegrationsHeader = (props: IHeaderProps) => {
  const { integrationsToShow } = useSelector(selectIntegrations)
  const dispatch = useDispatch()
  const { pageTitle } = props
  const { session } = useSelector(selectUser)

  return (
    <div className="w-full absolute h-[74px] flex" style={{ top: inPov(session) ? '42px' : '0px' }}>
      <div className="h-[26px] flex items-center mt-6 ml-6 w-[182px]">
        <LogoGradientIcon height="26" width="71" />
      </div>
      <div className="flex items-center flex-grow">
        <div className="font-semibold text-mainText text-xl ml-4">{pageTitle}</div>
        <SegmentedControl.Root
          value={integrationsToShow}
          defaultValue="active"
          className="h-[38px] mx-auto bg-controllerBackground text-controllerText"
          onValueChange={(newValue: string) => dispatch(setIntegrationsToShow(newValue))}
        >
          <SegmentedControl.Item value="active">
            <div className="flex">Active</div>
          </SegmentedControl.Item>
          <SegmentedControl.Item value="available">
            <div className="flex">Available</div>
          </SegmentedControl.Item>
        </SegmentedControl.Root>
      </div>
      <div className="flex items-center justify-end p-4">
        <div
          className="h-8 px-3 bg-neutral-1 dark:bg-transparent rounded border border-neutral-5 justify-center items-center gap-2 inline-flex cursor-pointer"
          onClick={() => (window.location.href = 'mailto:sales@iverify.io')}
        >
          <div className="text-paginationSelected text-sm leading-tight">Request Integration</div>
        </div>
      </div>
    </div>
  )
}

export default IntegrationsHeader
